import React, { useState, useEffect } from 'react';
import MenuItem from '@mui/material/MenuItem';
import { TextField, InputLabel } from '@mui/material';
import { api } from 'src/Api';

export default function PropertyStatusDropdown({ setRole, fullWidth, alreadyRole }) {
  console.log('alreadyRole', alreadyRole);
  const [roles, setRoles] = useState([]);
  const [reasondrop, setReasondrop] = useState(null);
  useEffect(() => {
    const getRoles = async () => {
      const requestOptions = {
        method: 'GET', // 'GET' should be capitalized
        redirect: 'follow'
      };
      const params = new URLSearchParams();
      params.append('type', 'job');
      try {
        const response = await fetch(`${api.get_user_status}?${params.toString()}`, requestOptions);
        // fetch(api.get_user_status, requestOptions);
        if (response.status === 200) {
          const result = await response.json();
          const rolesData = result.data;
          setRoles(rolesData);
          if (alreadyRole) {
            const defaultRole =
              rolesData.find((role) => role.name.toLowerCase() === alreadyRole.toLowerCase()) ||
              null;
            setReasondrop(defaultRole);
          }
        } else {
          console.error('Error fetching roles:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error fetching roles:', error);
      }
    };

    getRoles();
  }, [alreadyRole]);

  const handleChange = (event) => {
    const selectedRole = event.target.value;
    setRole(selectedRole);
    setReasondrop(selectedRole);
  };
  const currentStatus = alreadyRole;
  const updatedStatusOptions = roles.filter((option) => {
    if (currentStatus == 'active') {
      return ['Delete'].includes(option?.name);
    }
    if (currentStatus === 'blocked') {
      return ['Active', 'Delete'].includes(option?.name);
    }
    if (currentStatus === 'deleted') {
      return ['Active'].includes(option?.name);
    }

    if (currentStatus === 'hired') {
      return ['Delete'].includes(option?.name);
    }
    if (currentStatus == 'pending') {
      return ['Active', 'Delete'].includes(option?.name);
    }
    return true; // If none of the conditions match, return all options
  });

  return (
    <>
      <TextField
        fullWidth={fullWidth}
        style={{ width: !fullWidth && '20%', marginLeft: !fullWidth && 15 }}
        select
        value={reasondrop || ''}
        label={'Select status'}
        onChange={handleChange}
        variant="outlined"
      >
        {updatedStatusOptions.map((option) => (
          <MenuItem key={option.id} value={option}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
